import React, { useState } from "react"
import { Title, Text } from "ui/Typography"
import styles from "./ProgressRow.module.css"
import { useTranslation } from "react-i18next"
import { Button, Progress, Row, Col, Tag } from "antd"
import { useNavigate } from "react-router-dom"
import { routes } from "router"
import { useProgressValue } from "../PersonalInfoLayout/useCompletion"
import { ContactSupportModal } from "ui/ContactSupportModal"
import PropTypes from "prop-types"

export const ProgressRow = ({ isPending }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const progressValue = useProgressValue()
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const onButtonClick = () => navigate(routes.proPersonalInfoRootPath())
  const onContactClick = () => setIsContactModalOpen(true)

  if (isPending) {
    // New UI for pending status
    return (
      <div className={styles.pendingContainer}>
        <Row gutter={[4, 4]} justify="space-between" align="middle">
          <Col>
            <Tag color="blue">{t("pro.verification_status.pending_app")} </Tag>
          </Col>
          <Col>
            <Title level={4} className="mb-0">
              {t("pro.verification_status.in_pending_header_text")}
            </Title>
          </Col>
          <Col>
            <Text>{t("pro.verification_status.have_any_questions")}</Text>
            <Button className="pr-l pl-l ml-xs" color="primary" variant="outlined" onClick={onContactClick}>
              {t("pro.verification_status.contactSupport")}
            </Button>
          </Col>
        </Row>
        <ContactSupportModal open={isContactModalOpen} setOpen={setIsContactModalOpen} />
      </div>
    )
  }

  return (
    <div className={styles.progress}>
      <div>
        <Progress
          percent={progressValue}
          size={[133, 20]}
          percentPosition={{ align: "end", type: "inner" }}
          trailColor="#fff"
          format={(percent) => <div className={styles.progressNumber}>{percent}%</div>}
        />
      </div>
      <Title level={4} className="mb-0">
        {t("pro.verification_status.in_progress_header_text")}
      </Title>
      <Button className="pr-l pl-l" color="primary" variant="solid" onClick={onButtonClick}>
        {t("pro.verification_status.continueSetup")}
      </Button>
    </div>
  )
}

ProgressRow.propTypes = {
  isPending: PropTypes.bool.isRequired
}
